const CheckboxInput = ({ title, identifier, inputType, ...attributes }) => {
  return (
    <>
      <input
        id={`lws-${identifier}`}
        type={inputType}
        name={identifier}
        className="w-4 h-4"
        {...attributes}
      />
      <label htmlFor={`lws-${identifier}`} className="ml-2 text-sm">
        {title}
      </label>
    </>
  );
};

export default CheckboxInput;
